import React, { useState } from "react";
import { Card, Form, Button } from "react-bootstrap";
import avatar from "../Image/avatar.jpg";

export default function Profile() {
  const [preview, setPreview] = useState(null);
  const [file, setFile] = useState(null);

  const handleImageChange = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;

    const allowedTypes = ["image/png", "image/jpeg", "image/jpg", "image/gif"];
    if (!allowedTypes.includes(selectedFile.type)) {
      alert("Only gif, jpg, jpeg, png allowed");
      return;
    }

    setFile(selectedFile);
    setPreview(URL.createObjectURL(selectedFile));
  };

  const handleSubmit = () => {
    if (!file) {
      alert("Please select image");
      return;
    }
    console.log("Uploaded file:", file);
  };

  return (
    <Card className="shadow-sm">
      <Card.Body>
        <h6 className="mb-3">Profile Picture</h6>
        <hr />

        {/* Image Preview */}
        <div className="mb-3">
          <div
            style={{
              width: 120,
              height: 120,
              borderRadius: 6,
              backgroundColor: "#b0b8cf",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              overflow: "hidden",
            }}
          >
            {preview ? (
              <img
                src={preview}
                alt="preview"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            ) : (
              <img
  src={avatar}
  alt="Avatar"
  width={80}
  height={80}
  className="rounded-circle"
/>
                
            )}
          </div>

          <div style={{ marginTop: 6, fontSize: 14, color: "#7a7a7a" }}>
            Image <span style={{ color: "red" }}>*</span>
          </div>
        </div>

        {/* File input */}
        <Form.Group className="mb-3">
          <Form.Label>
            Image <span className="text-danger">*</span>
          </Form.Label>
          <Form.Text className="d-block mb-1">(gif,jpg,png,jpeg)</Form.Text>
          <Form.Control type="file" onChange={handleImageChange} />
        </Form.Group>

         <Button variant="primary" onClick={handleSubmit}>
              Save
            </Button>
      </Card.Body>
    </Card>
  );
}

